var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.items),function(item,i){return _c('v-btn',{key:i,staticClass:"ma-2",attrs:{"fab":"","color":"primary","small":""}},[_c('v-icon',{domProps:{"textContent":_vm._s(item.icon)}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }